import { Action, createReducer, on } from '@ngrx/store';
import * as actions from '../actions';
import { IBankProofDocument } from '../models/bank-proof-documents.model';

export const archivedBankProofDocumentsFeatureKey = 'archivedBankProofDocuments';

export interface ArchivedBankProofDocumentsState {
  loadArchivedBankProofDocuments: any;
  loadArchivedBankProofDocumentsSuccess: IBankProofDocument[];
  loadArchivedBankProofDocumentsFailure: Error | any;
}

export const initialState: ArchivedBankProofDocumentsState = {
  loadArchivedBankProofDocuments: undefined,
  loadArchivedBankProofDocumentsSuccess: undefined,
  loadArchivedBankProofDocumentsFailure: undefined
};

export const reducer = createReducer(
  initialState,
  on(actions.fromBankProofDocumentsActions.loadArchivedBankProofDocuments, (state, action) => ({
    ...state,
    loadArchivedBankProofDocuments: {
      customerId: action.customerId,
      bankAccountId: action.bankAccountId
    },
    loadArchivedBankProofDocumentsSuccess: undefined,
    loadArchivedBankProofDocumentsFailure: undefined
  })),
  on(actions.fromBankProofDocumentsActions.clearBankProofDocumentsUiState, () => ({ ...initialState })),
  on(actions.fromBankProofDocumentsActions.loadArchivedBankProofDocumentsSuccess, (state, action) => ({
    ...state,
    loadArchivedBankProofDocumentsSuccess: action.response
  })),
  on(actions.fromBankProofDocumentsActions.loadArchivedBankProofDocumentsFailure, (state, action) => ({
    ...state,
    loadArchivedBankProofDocumentsFailure: action.error
  }))
);

export const getArchivedBankProofDocuments = (state: ArchivedBankProofDocumentsState) => state.loadArchivedBankProofDocumentsSuccess;
